import React, { Component } from 'react';
import { Provider } from 'react-redux';
import {
  BrowserRouter,
  Route,
  Switch,
} from 'react-router-dom';
import { shape } from 'prop-types';
import NotFoundPage from '../../NotFoundPage';
import App from './App';
import styles from './Root.scss';

class Root extends Component {
  componentWillUnmount() {
    this.props.store.dispatch({ type: 'RESET_STORE' });
  }

  render() {
    const { store } = this.props;
    return (
      <div className={styles.rootContainer}>
        <div className={styles.rootContent}>
          <Provider store={store}>
            <BrowserRouter basename="/tracking">
              <Switch>
                <Route path="/:trackingPageName" component={App} />
                <Route component={NotFoundPage} />
              </Switch>
            </BrowserRouter>
          </Provider>
        </div>

      </div>
    );
  }
}

Root.defaultProps = {
  store: {},
};

Root.propTypes = {
  store: shape({}),
};

export default Root;
